import config from '../../../config.json'

export default function stripeCheckoutRedirectHTML(
  checkoutSessionId,
  stripePublicKey
) {
  if (!checkoutSessionId) {
    throw new Error('Invalid checkoutSessionId')
  }

  return `
  <html>
    <head>
      <!-- Load Stripe.js on your website. -->
      <script src="https://js.stripe.com/v3"></script>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <title>Stripe Checkout</title>
      <meta name="author" content="medandbeyond">  
    </head>
    <body>
    <!--<h1>Loading...</h1> -->
    <div class='center'>    
      <div class="loadingio-spinner-dual-ball-be6rxjm9wyk"><div class="ldio-s1ccbkb8ay">
      <div></div><div></div><div></div>
      </div></div>
    </div>
    <style type="text/css">
      .center{
        padding: 10px;
        padding-top: 50%;
        text-align: center;
      }
      @keyframes ldio-s1ccbkb8ay-o {
          0%    { opacity: 1; transform: translate(0 0) }
        49.99% { opacity: 1; transform: translate(40px,0) }
        50%    { opacity: 0; transform: translate(40px,0) }
        100%    { opacity: 0; transform: translate(0,0) }
      }
      @keyframes ldio-s1ccbkb8ay {
          0% { transform: translate(0,0) }
        50% { transform: translate(40px,0) }
        100% { transform: translate(0,0) }
      }
      .ldio-s1ccbkb8ay div {
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        top: 30px;
        left: 10px;
      }
      .ldio-s1ccbkb8ay div:nth-child(1) {
        background: #fb6f44;
        animation: ldio-s1ccbkb8ay 0.78125s linear infinite;
        animation-delay: -0.390625s;
      }
      .ldio-s1ccbkb8ay div:nth-child(2) {
        background: #004c74;
        animation: ldio-s1ccbkb8ay 0.78125s linear infinite;
        animation-delay: 0s;
      }
      .ldio-s1ccbkb8ay div:nth-child(3) {
        background: #fb6f44;
        animation: ldio-s1ccbkb8ay-o 0.78125s linear infinite;
        animation-delay: -0.390625s;
      }
      .loadingio-spinner-dual-ball-be6rxjm9wyk {
        width: 91px;
        height: 91px;
        display: inline-block;
        overflow: hidden;
        background: none;
      }
      .ldio-s1ccbkb8ay {
        width: 100%;
        height: 100%;
        position: relative;
        transform: translateZ(0) scale(0.91);
        backface-visibility: hidden;
        transform-origin: 0 0; /* see note above */
      }
      .ldio-s1ccbkb8ay div { box-sizing: content-box; }
      /* generated by https://loading.io/ */
    </style>
      <div id="error-message"></div>
      <script>
        (function () {
          var stripe = Stripe('${stripePublicKey}');
          window.onload = function () {
            // When the customer clicks on the button, redirect
            // them to Checkout.
            stripe.redirectToCheckout({
              sessionId: '${checkoutSessionId}'
            })
              .then(function (result) {
                if (result.error) {
                  // If redirectToCheckout fails due to a browser or network
                  // error, display the localized error message to your customer.
                  var displayError = document.getElementById('error-message');
                  displayError.textContent = result.error.message;
                }
              });
          };
        })();
      </script>
    </body>
  </html>
  `
}
